
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/youthpolicy",
      function () {
        return require("private-next-pages/youthpolicy.tsx");
      }
    ]);
  